/** Viewport fijo en admin, salvo presets de reglas: ahí scrollea la página. */
export function locksViewportScrollForPath(pathname: string): boolean {
  if (pathname.startsWith('/configuration/shipping-rule-presets')) {
    return false;
  }

  return (
    pathname === '/locations/staging-zones' ||
    /^\/wholesale-orders\/\d+\/preparation$/.test(pathname) ||
    pathname === '/refunds' ||
    pathname.startsWith('/configuration') ||
    pathname === '/invoices/eligible-shipments' ||
    pathname === '/invoices/eligible-storage' ||
    pathname === '/logistics/sla/alerts' ||
    pathname === '/logistics/sla/claims' ||
    pathname.startsWith('/invoices/view') ||
    pathname.startsWith('/warehouse/stock-movements')
  );
}
